import React, { useRef, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { VStack, Input, useToast } from '@chakra-ui/react'

import {
  Card,
  Form,
  Page,
  PageHeader,
  ButtonSave,
  ButtonCancel,
  FieldList,
  FieldListItem,
  FormField
} from 'components'

import { useConfigDetailQuery, useConfigUpdateMutation } from '../hooks'

export const ConfigEditPage = props => {
  const ref = useRef()
  const toast = useToast()
  const navigate = useNavigate()
  const { configId } = useParams()
  const [configUpdate] = useConfigUpdateMutation(configId)
  const config = useConfigDetailQuery(configId)

  const handleBack = useCallback(() => navigate('..'), [navigate])
  const handleSave = useCallback(() => ref.current.submit(), [ref])
  const handleCancel = useCallback(() => navigate('..'), [navigate])

  const handleUpdate = useCallback(
    async config => {
      const { data } = await configUpdate({ config })
      if (data?.errors?.length) {
        console.error(data.errors) // @TODO
        toast({
          status: 'error',
          title: 'Erro ao editar configuração.',
          description: 'Ocorreu um erro ao editar a configuração'
        })
      } else {
        toast({
          status: 'success',
          title: 'Configuração editada.',
          description: 'A configuração foi editado com sucesso.'
        })
        navigate(`..`)
      }
    },
    [toast, navigate, configUpdate]
  )

  return (
    <Page>
      <PageHeader onBack={handleBack} heading={`Editar Questionário #${configId}`}>
        <ButtonSave onClick={handleSave} />
        <ButtonCancel onClick={handleCancel} />
      </PageHeader>

      <Form ref={ref} data={config.data} onSubmit={handleUpdate} isLoading={config.loading}>
        <VStack align='stretch'>
          <Card>
            <FieldList>
              <FieldListItem label='Nome'>
                <Input type='text' isReadOnly value={config?.data?.name} />
              </FieldListItem>

              <FieldListItem label='Descrição'>
                <Input type='text' isReadOnly value={config?.data?.description} />
              </FieldListItem>

              <FieldListItem isRequired label='Valor'>
                <FormField name='value'>
                  <Input type='text' />
                </FormField>
              </FieldListItem>
            </FieldList>
          </Card>
        </VStack>
      </Form>
    </Page>
  )
}

export default ConfigEditPage
